import { parsePastedDate } from '@asamco/utils';
import DevExpress from 'devextreme';

/** default settings for DX date box */
export const dxDateBoxDefaults: DevExpress.ui.dxDateBoxOptions = {
	displayFormat: 'dd/MM/yyyy',
	useMaskBehavior: true,
	onPaste: (e: any) => {
		const txt: string = e.event.clipboardData.getData('text');
		const date: Date = parsePastedDate(txt);
		if (date) {
			e.event.preventDefault();
			e.component.option('value', date);
		}
	},
};
